<template>
  <div id="fcc-event-faq">
    <h1 class="title-md">常見問題</h1>
    <div class="faq-list" v-for="(item, index) in items" :key="index" @click="toggleAccordion(index)" :id="'fcc-faq-q'+index">
      <div class="faq-title-wrapper accordion" :id="'fcc-faq-q'+index">
        <div class="title-md">{{ item.title }}</div>
        <div class="accordion-icon bg-contain" :class="{ 'icon-active': activeAccordion === index }"></div>
      </div>
      <div class="panel" :key="index" :class="{ 'active': activeAccordion === index }">
          {{ item.content }}
        <div v-html="item.url" style="display:inline"></div>
        <img :src="item.img">
      </div>
    </div>
    <div class="faq-list">
      <a href="https://support.ins.to/hc/zh-tw" target="_blank" style="width:100%; color:#000">
        <button class="faq-title-wrapper accordion">
          <div class="title-md" >更多問題請點我 Go</div>
          <div class="arrow-icon bg-contain"></div>
        </button>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: [
        { title: "如何申請？", content: "我們採全線上申請制，您可以透過手機下載 INSTO Tap App 完成註冊開始申請賣家，或直接點擊網頁版申請連結完成註冊及申請！",url:'<a href="https://merchant.ins.to/insto-apply/signup/" target="_blank" style="color:#0986F9; text-decoration:underline">網頁版申請連結</a>'},
        { title: "有任何額外的費用嗎？", content: "沒有任何隱藏額外費用，我們僅收取成交交易手續費！讓你輕輕鬆鬆入門擁有方便的收款工具。" },
        { title: "我想收國外卡，如何申請開通呢？", content: "當您首次提交賣家申請時，可在最後一步同步申請國外卡收款，快速又便利！或您也能在 App 首頁中間橫幅點選開通；或在 App 側邊選單>我的帳戶>收款方式>申請國外卡收款。*國外卡申辦需等候數個工作天審閱，審閱通過後會收到 E-mail 開通繳費單，完成繳費後即可開通喔！" ,url:'<a href="https://support.ins.to/hc/zh-tw/articles/4408209327641" target="_blank" style="color:#0986F9; text-decoration:underline">詳細可參閱</a>'},
        { title: "有限制哪家銀行才能當撥款帳戶嗎？", content: "沒有哦！國內任何一間銀行、郵局、農漁會等，都能作為 INSTO 的撥款帳戶！" },
        { title: "刷卡完成後，多久能拿到錢？", content: "系統將於每週四自動撥款 8 至 14 天前的款項（約 1 至 2 週前），並在撥款完成後發送 App 推播與 E-mail 通知。",img:require('../../assets/imgs/event/foreign-card/withdrawal-image.png') },
        { title: "收款有多少交易使用額度呢？", content: "個人賣家每月有15萬的交易額度；企業賣家每月有80萬的交易額度。",url:'<a href="https://tap.ins.to/pricing" target="_blank" style="color:#0986F9; text-decoration:underline">詳細可參閱</a>'},
      ],
      activeAccordion: null
    };
  },
  methods: {
    toggleAccordion(index) {
      if (this.activeAccordion === index) {
        this.activeAccordion = null;
      } else {
        this.activeAccordion = index;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
  @import "@/assets/sass/foreign-credit-card.scss";

#fcc-event-faq {
  padding: 80px 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;

  @media screen and (max-width: 1552px) {
    padding: 60px 100px;
    width: 100%;
  }

  @media screen and (max-width: 1024px) {
    padding: 50px;
  }

  @media screen and (max-width: 768px) {
    padding: 40px 20px;
  }

  h1 {
    margin: 0;
  }

  .faq-list {
    width: 100%;
    border-bottom: 1px solid black;
    padding: 12px 0;
    color: black;

    a {
      color: black;
    }

    .title-md {
      padding: 0;
      font-weight: normal !important;
    }

    img {
      display: block;
      width: 50%;
      margin: 10px auto;
      @media screen and (max-width: 1024px) {
        width: 100%;
      }
    }
  }

  .accordion {
    width: 100%;
    outline: none;
    border: none;
    background-color: transparent;
    cursor: pointer;
    text-align: left;
    padding: 16px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

.accordion-icon {
  cursor: pointer;
  background-image: url('../../assets/imgs/event/foreign-card/trigger-icon.svg');
  width: 36px;
  height: 36px;
  margin-left: 20px;
  transition: all .3s ease-in-out;
  flex-shrink: 0;
  &:hover {
    transform: rotate(45deg);
  }
}

.panel {
  text-align: left;
  background-color: #fff;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.2s ease-out;
  font-size: 16px;
  line-height: 1.5;
}

.active {
  max-height: 100%;
}

.icon-active {
  transform: rotate(45deg);
}

.arrow-icon {
  background-image: url('../../assets/imgs/event/foreign-card/arrow.svg');
  width: 36px;
  height: 36px;
  margin-left: 20px;
  cursor: pointer;
  transition: all .3s ease-in-out;

  &:hover {
    transform: translateX(-4px);
  }
}

</style>
